<ng-multiselect-dropdown [settings]="settings" [data]="data" [disabled]="isDisabled"
    (onSelect)="onSelectInternal($event)" (onDeSelect)="onDeSelectInternal($event)" (onFilterChange)="onFilterChangeInternal($event)"
    (onSelectAll)="onSelectAllInternal()" [placeholder]="placeholder" [(ngModel)]="selectedItems" ngDefaultControl>
</ng-multiselect-dropdown>
<div *ngIf="required && !selectedItems.length" class="input-required">
    <ng-content></ng-content>
</div>
<div *ngIf="isOtherSelected && formControlNameOther" class="col-xs-12">
    <input class="form-control" [placeholder]="placeholder" (keyup)="otherInputTextBoxChange()" [ngClass]="classOther"
        [disabled]="isDisabled || textReadOnly" [(ngModel)]="otherValue">
</div>